import axios from 'axios'
import qs from 'qs'
import serverConfig from './serverConfig'
import router from '../router'

axios.interceptors.request.use(config => config, Promise.reject)

axios.interceptors.response.use(response => response, error => Promise.resolve(error.response))

if (process.env.BUILD_ENV === 'production') {
  axios.defaults.baseURL = serverConfig.formalServer
}

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && (response.status === 200 || response.status === 304 || response.status === 400)) return response
  // 如果不需要除了data之外的数据，可以直接 return response.data
  // 异常状态下，把错误信息返回去
  return {status: -404, msg: '网络异常'}
}

function checkCode(res) {
  if (res.data && String(res.data.resultCode) === '4001') {
    router.push({path: '/login'})
    sessionStorage.removeItem('token')
    // sessionStorage.removeItem('accessToken') // 清除用户登录的token
    // sessionStorage.removeItem('loginStatus') // 重置用户登录状态
    // console.log(res.data.msg)
  }
  return res
}

const getWebRequestUrl = () => window.location.href.split('#')[1]

export default {
  get(url, params) {
    let requestUrl = url
    if (process.env.BUILD_ENV === 'production') {
      requestUrl = requestUrl.replace('/web', '')
    }
    return axios({
      method: 'get',
      url: requestUrl,
      params,
      timeout: 20000
    })
      .then(checkStatus)
      .then(checkCode)
  },
  post(url, data) {
    let requestUrl = url
    if (process.env.BUILD_ENV === 'production') {
      requestUrl = requestUrl.replace('/web', '')
    }
    let newData = data
    if (sessionStorage.getItem('token')) {
      Object.assign(newData, {
        '_sid_token_': sessionStorage.getItem('token'),
        timestamp: (new Date()).valueOf()
      })
    }
    return axios({
      method: 'post',
      url: requestUrl,
      data: qs.stringify(newData),
      timeout: 20000,
      headers: {
        'X-Requested-uri': getWebRequestUrl(),
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    })
      .then(checkStatus)
      .then(checkCode)
  }
}



// WEBPACK FOOTER //
// ./src/util/http.js